export enum GeolobsCategoryEnum {
  Rautitan = 'RAUTITAN',
  Raupiano = 'RAUPIANO',
  PanelHeatingAndCooling = 'Panel heating / cooling',
  NeaSmart20 = 'NEA SMART 2.0',
  ReSourceShowroom = 'RE.SOURCE Showroom',
  ReSource = 'RE.SOURCE',
  ReGuard = 'RE.GUARD',
}
